import React from 'react';
import Dasara2024 from 'views/Dasara2024'

const SchoolProgrampage = () => {
  return <Dasara2024 />;
};

export default SchoolProgrampage;